import SignUpLayer from "../components/SignUpLayer";

const SignUpPage = () => {
  return (
    <>
      {/* SignUpLayer */}
      <SignUpLayer />
    </>
  );
};

export default SignUpPage;
